import React from "react";
import { Modal, ModalBody, ModalHeader, Button } from "reactstrap";

interface DeleteModalProps {
  show: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title?: string;
  message?: string;
}

const NewDeleteModal: React.FC<DeleteModalProps> = ({
  show,
  onClose,
  onConfirm,
  title = "Confirm Delete",
  message = "Are you sure you want to delete this item?",
}) => {
  return (
    <Modal isOpen={show} toggle={onClose} centered>
      <ModalHeader toggle={onClose}>{title}</ModalHeader>

      <ModalBody className="text-center">
        <h5>{message}</h5>
        <p className="text-muted">This action cannot be undone.</p>

        <div className="d-flex justify-content-center gap-3 mt-4">
          <Button color="secondary" onClick={onClose}>
            Cancel
          </Button>

          <Button color="danger" onClick={onConfirm}>
            Delete
          </Button>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default NewDeleteModal;
